module.exports = __webpack_public_path__ + "static/media/chartsJs.ed2f373e.svg";